import React from "react";
import { Row, Col, Grid ,FormGroup,Form,FormControl ,ControlLabel,Checkbox,MenuItem,DropdownButton,ButtonToolbar} from 'react-bootstrap'
import Features from "../Features/Features";
import Breadcrumbing from "../Breadcrumbing/Breadcrumbing";
import Signwith from "../Signwith/Signwith";

class EmailSent  extends React.Component {
	
	 render() {     
		return (

            <Grid>
            <Breadcrumbing {...this.props}/>

   <div className="Emailsent ForgorPassword  cartempty">
<Row>
            <Col md={6} mdOffset={3}>
            <div className="ForgorPassword-caption">

       <h3 className="">E-mAIL SENTt </h3>

       <p> An E-Mail has been sent to your email address
 <span class="Emailsent_name"> Ma@ma.com </span>  Check your inbox and follow the instructions
to get a new password for your account </p>
<div className="Emailsent__countdown">
<h3> 05 </h3>

</div>

       </div>
       <div className="Emailsent__second-caption">
       <p>This page will automatically redirect to home page
or you can <span className="Emailsent__link"> <a href="/">click her  </a> </span> to redirect </p>
</div>

    

          </Col>
          </Row>

          </div>

          </Grid>

       );
    }
  }
  
  export default EmailSent;
  


// WEBPACK FOOTER //
// ./src/Components/EmailSent/EmailSent.jsx